var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge text-white",class:_vm.variant},[_vm._v("\n    "+_vm._s(_vm.psp)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }